import React, { Fragment } from 'react'
import { Redirect } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import Toolbar from '@material-ui/core/Toolbar'
import Footer from '../Admin_Footer/Admin_Footer'
import CssBaseline from '@material-ui/core/CssBaseline'
import DrawerMenu from './DrawerMenu'

// import Login from '../auth/Login'

const useStyles = makeStyles((theme) => {
    return {
        page: {
            background: '#F9FAFC',
            width: '100%',
            padding: theme.spacing(2),
        },
        root: {
            display: 'flex',
        },
        active: {
            background: '#F6F9FD',
            color: '#2C3590',
            borderRadius: 4,
            borderLeft: '3px Solid #15B9EC',
        },
        activeIcon: {
            color: '#2C3590',
        },
        notActive: {
            borderLeft: '3px Solid transparent',
        },
        appbar: {
            zIndex: theme.zIndex.drawer + 1,
        },
        drawerContainer: {
            overflow: 'auto',
        },

        avtrLarge: {
            width: 100,
            height: 100,
        },
        avtrWrap: {
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: theme.spacing(2),
        },
        avtarName: {
            fontSize: 16,
            fontWeight: 'normal',
            marginTop: 16,
        },
        avtarDesignation: {
            fontSize: 12,
            fontWeight: 'normal',
        },
    }
})

const Admin_Layout = ({ children }) => {
    const classes = useStyles()

    const authLinks = (
        <Fragment>
            <DrawerMenu />
            <div className={classes.page}>
                <Toolbar />
                {children}
                <Footer />
            </div>
        </Fragment>
    )

    return (
        <div className={classes.root}>
            <CssBaseline />
            <Fragment>{authLinks}</Fragment>

        </div>
    )
}

export default Admin_Layout
